// extracted by mini-css-extract-plugin
export default {"wrapper":"H0Kh53","headingsContainer":"NVwBXJ","titleContainer":"ZF13jG","subtitleContainer":"TsBm0Z","imageContainer":"lHtvJ_","bowlImage":"_PdbTo"};